// extracted by mini-css-extract-plugin
module.exports = {"container":"admin_container__1OKhs","header":"admin_header__2x4Qv"};